import Link from "next/link";

// https://holomate.imgix.net/pics/bots
export default function BotListItem({bot}) {
    return <Link href={"/mate/"+ bot.botId}><div className="flex flex-col mb-2 md:mb-4 overflow-x-hidden gap-2 h-full">
        <div className="" style={{width: "calc(100% + 12px)",
            height: "auto",
            overflow: "hidden",
            position: "relative",
            left: "-6px", minWidth: "6rem" /*minHeight: "638px*/}}> 
            <img className="" src={"https://d1vc7bbgzsrk4.cloudfront.net/chatmates/profiles/generated_image_" + bot.botId + "_w240.png"} style={{  width: "100%",
                height: "auto",
                display: "block", maxWidth: "252px"}} loading="lazy"
                alt={"Chatmate.AI #" + bot.botId + " - " + bot.bot_name + ", " + bot.bot_age}
                />
        </div>
        <div className="font-bold text-black text-sm text-center flex">
            <div className="text-center border rounded-full  m-auto px-4">
                {bot.properties.bot_name} {bot.properties.bot_lastname}, {bot.properties.bot_age}
            </div>
        </div>
    </div></Link>
}